import { useLocation, useNavigate } from 'react-router-dom';

import MobileSidebarNavItem from './MobileSidebarNavItem';
import LegalLinks from '@/shared/components/legal/LegalLinks';

import type { SidebarMenuItem } from '@/shared/components/layout/types';

/**
 * 모바일(Capacitor) 셸 사이드바 네비게이션 아이템 컨테이너.
 * 앱은 항상 드로어(모바일)로만 열린다 — 드로어(MobileGlobalSidebar의 Aside)가 폭을 잡고
 * 슬라이드 인/아웃을 담당하므로, 여기서는 그 안을 100%로 채우기만 한다.
 * 데스크톱 셸의 SidebarNavItemContainer(레일 확장/축소 애니메이션)와는 별개 구현.
 */
export default function MobileSidebarNavItemContainer({ menu }: { menu: SidebarMenuItem[] }) {
  // 라우터 구독은 여기 한 곳에서만 한다 — 각 행이 직접 구독하면 memo를 통과하지 못해
  // 쿼리 파라미터만 바뀌어도 메뉴 트리 전체가 리렌더된다.
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <nav className='bg-basic-white border-r-table-line custom_scroll scroll_y_only absolute inset-0 z-50 flex flex-col items-stretch border-r pt-4 pb-[env(safe-area-inset-bottom)]'>
      <ul className='flex w-full flex-col gap-2'>
        {menu?.map((menuItem, index) => (
          <li className='flex w-full flex-col' key={`${menuItem.id}-${index}`}>
            <MobileSidebarNavItem menuItem={menuItem} pathname={pathname} navigate={navigate} />
          </li>
        ))}
      </ul>

      <LegalLinks className='mt-auto px-5 py-4' />
    </nav>
  );
}
